import React, { useState } from 'react';
import '../css/ContactUS.css';
import ContactForm1 from '../components/ContactForm1';
import Section from '../components/Section';
import qrcode from '../assets/images/WhatsUpQRCode.png';


const ContactUs: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission, like sending the data to an API or email service
    console.log(formData);
  };

  return (
    <><Section subtitle="Contact Us" title="" />
      
    <div className="container mt-4">
      <div className="row">
        {/* Contact Form */}
        <div className="col-md-8">
      <ContactForm1 />
    </div>
       {/* Location Details */}
       <div className="col-md-4 clscontact">
          <div className="p-4 border rounded shadow-sm">
            <h5 className="fw-bold">Our Location</h5>
            <hr />
            <div className="mb-3">
              <h6 className="fw-bold">
                <img src="https://cdn-icons-png.flaticon.com/512/197/197419.png" alt="India" width="20" /> INDIA
              </h6>
              <p className="mb-1"><i className="bi bi-geo-alt text-dark"></i>P-402, SG Business Hub, Near IOCL Petrol Pump, SG Highway - Gota, Ahmedabad 380060, Gujarat, India</p>
              <p className="mb-1"><i className="bi bi-telephone text-dark"></i>
              {/* <i className="fa-brands fa-whatsapp"></i> */}
                                  +91 6359320518 <br/><i className="bi bi-telephone text-dark"></i>+91 8347084437</p>
                              <p><i className="bi bi-envelope text-dark"></i> sales@tuc.org.in
                              <br/><i className="bi bi-envelope text-dark"></i> mkt@tuc.org.in</p>
            </div>
          </div>
          <div className="p-4 border rounded shadow-sm">
            <img
            src={qrcode}
            alt="WhatsApp QR Code"
            className="w-40 h-40 rounded-md border"
          />
          <p className="text-sm text-gray-600 mt-2">
            Scan the QR code to chat with us on WhatsApp.
          </p>
          </div>
        </div>
        <div className="flex flex-col items-center mb-6">
         
        </div>

      </div>
    </div></>
  );
};

export default ContactUs;
